// export enum OrderColumns {
//     NUMBER = "number",
//     DATE = "date",
//     ORDER_TYPE = "orderType",
//     ASSET_TYPE = "assetType",
//     STATUS = "status",
//     SUM = "sum",
//     CURRENCY = "currency",
//     PDF = 'pdf',
// }

export enum OrderStatus {
  DRAFT = 'Черновик',
  IN_PROGRESS = 'В обработке',
  IN_WAITING_VIEW = 'Ожидает рассмотрения',
  SUCCESS = 'Исполнена',
  CANCELLED = 'Отменена',
}

export enum OrderType {
  BUY = 'Покупка',
  SELL = 'Продажа',
  INCOME = 'Ввод',
  OUTCOME = 'Вывод',
}

export enum AssetType {
  CURRENCY = 'Валюта',
  SHARE = 'Ценная бумага',
  VIRTUAL_ASSET = 'Виртуальный актив',
}

export interface Order {
  fileId?: string;
  verifyCode?: string;
  orderId?: string;
  currencyId?: string;
  assetType?: AssetType;
  orderType?: OrderType;
  status?: OrderStatus;
  curs?: number;
  currPair?: string;
  quantity?: string; // Кол-во акций
  shareName?: string;
  virtualAssetId?: string;
  sum?: string;
  number?: string;
  date?: string;
  corrCurrencyId?: string;
  recipientBank?: string;
  depositoryName?: string;
  personalAccountNumber?: string;
  depoAccount?: string;
  invoiceSection?: string;
  indetifier?: string;
  depoAccountHolder?: string;
  numberAndDateAgreement?: string;
  comment?: '';
}

export interface OrderFilters {
  currencyId?: string;
  orderId?: string;
  assetType?: AssetType;
  orderType?: OrderType;
  status?: OrderStatus;
  number?: string;
}

export type SortDirection = '+' | '-';

interface OrderBy {
  currencyId?: SortDirection;
  assetType?: SortDirection;
  orderType?: SortDirection;
  status?: SortDirection;
  number?: SortDirection;
  date?: SortDirection;
}

export interface GetOrdersRequest {
  period?: [string, string];
  limit?: number;
  offset?: number;
  dateBeg?: string | null;
  dateEnd?: string | null;
  filters?: OrderFilters;
  orderbys?: OrderBy;
}

export interface CreateOrderDto {
  // "orderID": string - если хотим измениь черновик заявки
  sum: string;
  orderType: OrderType;
  assetType: AssetType;
  currencyId: string; // USD - Валюта которую покупаем
  corrCurrencyId: string; // Китайский Юань - за счет нее
  comment: string;
}
